import React, { useState } from "react";
import { useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  TextField,
  Grid,
  MenuItem,
  TableContainer,
  Slider,
  withStyles,
} from "@material-ui/core";
import { useEffect } from "react";
import {
  getPinCode,
  createNewCenter,
  getAgentList,
  getStateList,
  getpaymentMoodList,
  getCenterInfo,
  getSalesManager,
  getSalesExecutive,
  updateCenter,
  getIdentityProof,
  getRateListFilter,
  getTagProcessingLab,
  getCentreCode,
  getBankName,
  getPackageByCenter,
} from "../../actions/GenomicsAdminAction";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Loader from "../../Components/loader/index";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import { TableFooter, TablePagination } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormGroup from "@material-ui/core/FormGroup";
import "./index.sass";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "0rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    centerIt: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

const PrettoSlider = withStyles({
  root: {
    color: "rgb(146, 74, 145)",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "violet",
    border: "2px solid purple",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

interface Props {
  getCentreCode: any;
  centreCode: any;
  getCenterInfo: any;
  getPinCode: any;
  centerInfo: any;
  pin_code: any;
  createNewCenter: any;
  getAgentList: any;
  agentBYUserGroup: any;
  getSalesExecutive: any;
  getSalesManager: any;
  salesManager: any;
  salesExecutive: any;
  updateCenter: any;
  getIdentityProof: any;
  identityProofData: any;
  getStateList: any;
  stateList: any;
  getpaymentMoodList: any;
  paymentModeList: any;
  getRateListFilter: any;
  rateListFilter: any;
  getTagProcessingLab: any;
  tagProccessingLab: any;
  getBankName: any;
  bankName: any;
  getMultiplePackage: any;
  multiplePackage: any;
  getPackageByCenter: any;
  centerPackages: any;
  loading: Boolean;
  allPackageList:any;
}
const CreateCentrePage: React.FC<Props> = ({
  getCentreCode,
  centreCode,
  getCenterInfo,
  getPinCode,
  centerInfo,
  pin_code,
  createNewCenter,
  getAgentList,
  agentBYUserGroup,
  getSalesExecutive,
  getSalesManager,
  salesManager,
  salesExecutive,
  identityProofData,
  updateCenter,
  getIdentityProof,
  getStateList,
  getpaymentMoodList,
  paymentModeList,
  getRateListFilter,
  rateListFilter,
  getTagProcessingLab,
  tagProccessingLab,
  stateList,
  getBankName,
  bankName,
  getMultiplePackage,
  multiplePackage,
  centerPackages,
  getPackageByCenter,
  loading,
  allPackageList,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [page, setPage] = useState(0);
  const [isAllPkg, setIsAllPkg] = useState<any>(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [centerId, setCenterId] = useState<any>();
  const [centerTypeFilter, setCentreTypeFilter] = useState<any>("");
  const [warningForDOB, setWarningForDOB] = useState<any>("");
  const [name, setName] = useState<any>("");
  const [centerName, setCentreName] = useState<any>("");
  const [centerType, setCentreType] = useState<any>("");
  const [centerDef, setCenterDef] = useState<any>([]);
  // const [patientType, setPaitentType] = useState<any>("")
  const [identityProof, setIdentityProof] = useState<any>("");
  const [centerCode, setCentreCode] = useState<any>("");
  const [expiryDate, setExpiryDate] = useState<any>("");
  const [contractDate, setContractDate] = useState<any>("");
  const [mobileNumber, setMobileNumber] = useState<any>("");
  const [packageDef, setPackageDef] = useState<any>([]);
  const [altNumber, setaltNumber] = useState<any>("");
  const [sales_Manager, setSales_Manager] = useState<any>("");
  const [sales_ManagerDef, setSales_ManagerDef] = useState<any>("");
  const [sales_Executive, setSales_Executive] = useState<any>([]);
  const [sales_ExecutiveDef, setSales_ExecutiveDef] = useState<any>([]);
  const [ownerName, setOwnerName] = useState<any>("");
  const [midleName, setMidleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [selectedAgeType, setSelectedAgeType] = React.useState("age");
  const [centerAddress, setCentreAddress] = React.useState("");
  const [cityName, setCityName] = React.useState<String>("");
  const [cityId, setCityId] = React.useState<any>();
  const [pincode, setPinCode] = React.useState<Number>(0);
  const [nationality, setNationality] = React.useState("Indian");
  const [centerHeadalterNateNumber, setCentreHeadAlternateNumber] =
    useState<any>();
  const [centerHeadalContactNumber, setCentreHeadContactNumber] =
    useState<any>();
  const [state, setState] = useState<any>("");
  const [email, setEmail] = React.useState("");
  const [busyId, setBusyId] = React.useState("");
  const [adharNumber, setAdharNumber] = React.useState<any>("");
  const [genders, setGenders] = React.useState("");
  const [area, setArea] = React.useState<String>("");
  // const [securityAmount, setSecurityAmount] = React.useState("");
  const [serviceRateCategory, setServiceRateCategory] = React.useState<any>("");
  const [serviceRateCategoryDef, setServiceRateCategoryDef] =useState<any>({id:"",name:""});
  const [barCodeType, setBarCodeType] = React.useState<any>([]);
  const [tag_ProccessingLab, setTag_ProccessingLab] = React.useState("");
  const [categoryName, setCategoryName] = useState<any>("");
  const [tenure, setTenure] = React.useState("");
  const [paymentMode, setPaymentMode] = React.useState("");
  const [bankAccountHolder, setbankAccountHolder] = React.useState<any>("");
  const [bank, setBank] = React.useState<any>("");
  const [bankInput, setBankInput] = React.useState<any>("");
  const [gstinNumber, setGstinNumber] = React.useState<any>("");
  const [panNumber, setPanNumber] = React.useState<any>("");
  const [ifscCode, setIfscCode] = React.useState<any>("");
  const [accountNumber, setAccountNumber] = React.useState<any>("");
  const [minAmountForNotification, setMinNotication] = React.useState<any>("");
  const [minAmountForBill, setMinAmountForBill] = React.useState<any>(0);
  const [center_longitude, setCentreLongitude] = useState<any>("");
  const [center_latitude, setCentreLatitude] = useState<any>("");
  const [designation, setDesignation] = useState<any>("");
  const [displayDesignation, setDisplayDesignation] = useState<any>("");
  const [creditLimit, setCreditLimit] = useState<any>("");
  const [invoiceCycle, setInvoiceCycle] = useState<any>("");
  const [reportWhatsappSentTo, setReportWhatsappSentTo] = useState<any>("");
  const [reportEmailSentTo, setReportEmailSentTo] = useState<any>("");
  const [reportSmsSentTo, setReportSmsSentTo] = useState<any>("");
  const [packageRights, setPackageRights] = useState<any>("redcliffe");
  const [pinCodeId, setPincodeId] = useState<any>("");
  const [pinCodeIdDef, setPincodeIdDef] = useState<any>("");
  const [file, setFile] = React.useState<any>([]);
  const [disableEdit, setDisableEdit] = useState<boolean>(false);
  const [packageDetails, setPackageDetails] = useState<any>([]);
  const [packageIds, setPackageIds] = useState<any>([]);
  const [displayPackages, setDisplayPackages] = useState<any>("");
  const [packageKey, setPackageKey] = useState<any>(0);
  const [centrePackages, setCentrePackages] = useState<any>([]);
  const [price, setPrice] = useState<any>(0);
  const [discount, setDiscount] = useState<any>(0);
  const [totalPrice, setTotalPrice] = useState<any>(0);
  const [coupon, setCoupon] = useState<Number>(0);
  const [couponCode, setCouponCode] = useState<string>("");
  const [extraCharge, setExtraCharge] = useState<boolean>(false);
  const [redCashCheck, setRedCashCheck] = useState<boolean>(false);
  const [displaySalesManager, setDisplaySalesManager] = useState<any>("");
  const [displayServiceCategory, setDisplayServiceRateCategory] = useState<any>("");
  const [displayTagProcessingLab, setDisplayTagProcessingLab] = useState<any>("");
  const [center, setCenter] = useState<any>([]);

  const [smsType, setSmsType] = React.useState({
    mail: false,
    sms: false,
    screen: false,
    isbillinglock: false,
    isapproved: false,
    is_booking_payment_sms: false,
    is_booking_sms: false,
    is_report_sms: false,
    is_report_whatsapp: false,
    is_report_email: false,
    is_shown_to_pha: false,
    is_shown_to_sales: false,
    is_auto_verify: false,
    is_price_hide: false,
  });

  const [mobileValidation, setMobileValidation] = useState({
    mobileNumber: true,
    centerHeadalterNateNumber: true,
    centerHeadalContactNumber: true,
    altNumber: true,
  });
  const [centerShow, setCentreShow] = useState<any>(false);
  const [centerHeadShow, setCentreHeadShow] = useState<boolean>(false);
  const [centerBankShow, setCentreBankShow] = useState<boolean>(false);
  const [centerControlingShow, setCentreControllingShow] =
    useState<boolean>(false);
  const [assignLabId, setAssignLabId] = useState<any>(5);
  const [editButton, setEditButton] = useState<any>(false);
  const verifyMobile = (type: any) => {
    const mobileRegEx = /^[6-9]\d{9}$/;
    if (
      type === "mob" &&
      mobileNumber &&
      !mobileRegEx.test(mobileNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        mobileNumber: false,
      }));
    }
    if (
      type === "centAlt" &&
      altNumber &&
      !mobileRegEx.test(altNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        altNumber: false,
      }));
    }
    if (
      type === "contAlt" &&
      centerHeadalterNateNumber &&
      !mobileRegEx.test(centerHeadalterNateNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        centerHeadalterNateNumber: false,
      }));
    }
    if (
      type === "contMob" &&
      centerHeadalContactNumber &&
      !mobileRegEx.test(centerHeadalContactNumber.toString())
    ) {
      setMobileValidation((prev: any) => ({
        ...prev,
        centerHeadalContactNumber: false,
      }));
    }
  };

  const CenterTypeData = [
    {
      value: "hospital",
      text: "Hospital",
    },
    {
      value: "doctor",
      text: "Doctor",
    },
  ];

  const salutationData = [
    {
      value: "Mr",
      text: "Mr",
    },
    {
      value: "Master",
      text: "Master",
    },
    {
      value: "Miss",
      text: "Miss",
    },
    {
      value: "Smt",
      text: "Smt",
    },
    {
      value: "Dr.",
      text: "Dr.",
    },
    {
      value: "Baby or Just Born",
      text: "Baby or Just Born",
    },
  ];
  const fileSelectedHandler = (e: React.ChangeEvent<{ files: any }>) => {
    setFile(e.target.files[0]);
  };
  const [inputList, setInputList] = useState<any>([
    {
      customerPackage: [],
      packagePrice: 0,
    },
  ]);  const checkBuyOneGetOneFreePackage = (index: number, packages: any) => {
    if (
      inputList &&
      inputList?.length === 1 &&
      packages &&
      packages?.length > 0
    ) {
      packages.map((item: any) => {
        if (item && item.code === "PL50" && item?.code === "PL50") {
          // if use select buy one get one package
          setInputList([
            ...inputList,
            {
              customerDesignation: "",
              designation: "",
              customerName: "",
              customerAge: "",
              customerGender: "",
              customerPackage: [item],
              packagePrice: item?.offer_price,
              dateOfBirth: "",
            },
          ]);
        }
      });
    }
  };
  const checkNormalPackage = (packages: any) => {
    let isNormalPackage = false;
    packages &&
      packages.length > 0 &&
      packages.map((item: any) => {
        if (!item.is_addon) {
          isNormalPackage = true;
        }
      });
    return isNormalPackage;
  };

  const getNoofPackageBuyOneGetOne = () => {
    let noOfBuyOneGetOne = 0;
    inputList &&
      inputList.map((rowItem: any) => {
        if (rowItem?.customerPackage && rowItem?.customerPackage.length > 0) {
          rowItem?.customerPackage.map((packageItem: any) => {
            if (packageItem?.code === "PL50") {
              noOfBuyOneGetOne = noOfBuyOneGetOne + 1;
            }
          });
        }
      });
    return noOfBuyOneGetOne;
  };

  const buyOneGetOnePackagePrice = () => {
    let packagePrice = 0;
    inputList &&
      inputList.map((rowItem: any) => {
        if (rowItem?.customerPackage && rowItem?.customerPackage.length > 0) {
          rowItem?.customerPackage.map((packageItem: any) => {
            if (packageItem?.code === "PL50") {
              packagePrice = packageItem?.offer_price;
            }
          });
        }
      });
    return packagePrice;
  };

  useEffect(() => {
    getCenterInfo();
    getPinCode();
    getBankName();
    getSalesExecutive();
    getSalesManager();
    getStateList();
    getIdentityProof();
    getpaymentMoodList();
    // getRateListFilter();
    getTagProcessingLab();
    getPackageByCenter();
  }, []);

  useEffect(() => {
    if (centerType !== "") {
      getCentreCode(centerType);
    }
    
  }, [centerType]);

  useEffect(() => {
    if (centerType) {
      setCentreCode(centreCode?.centre_code);
      if(disableEdit === false){
        setCentreName(centerType === "doctor" ? "Dr. " : "");
      }
    }
  }, [centerType, centreCode]);  const handleSmsControl = (event: any) => {
    setSmsType({ ...smsType, [event.target.name]: event.target.checked });
  };

  const handleAgeTypeChange = (event: any) => {
    setSelectedAgeType(event.target.value);
  };
  const handleSubmitCentre = async (e: any) => {
    e.preventDefault();

    const formData = {
      name: centerName,
      display_name: centerName,
      org_type: "genomics",
      center_type: centerType,
      city: cityId,
      center_code: centerCode,
      contract_start_date: contractDate,
      contract_end_date: expiryDate,
      mobile: mobileNumber,
      alternative_phone: altNumber,
      email: email,
      sales_manager: sales_Manager,
      address: centerAddress,
      location: pinCodeId,
      barcode_type: barCodeType,
      type: categoryName,
      owner_salutation: designation,
      owner_name: ownerName,
      owner_alt_phone: centerHeadalterNateNumber,
      owner_phone: centerHeadalContactNumber,
      owner_nationality: nationality,
      pan: panNumber,
      account_holder_name: bankAccountHolder,
      bank_ifsc: ifscCode,
      packages_rights: packageRights,
      gstin: gstinNumber,
      bank_account_no: accountNumber,
      bank: bank,
      is_billing_lock: JSON.stringify(smsType.isbillinglock),
      min_amnt_for_notification: minAmountForNotification,
      min_amnt_for_billing_lock: String(minAmountForBill),
      multiple_ratelist: String(serviceRateCategory),
      invoice_cycle: invoiceCycle,
      test_category: [1],
      report_email_sent_to: reportEmailSentTo,
      report_sms_sent_to: reportSmsSentTo,
      report_whatsapp_sent_to: reportWhatsappSentTo,
      is_mail: JSON.stringify(smsType.mail),
      is_sms: JSON.stringify(smsType.sms),
      is_booking_payment_sms: JSON.stringify(smsType.is_booking_payment_sms),
      is_screen: JSON.stringify(smsType.screen),
      is_booking_sms: JSON.stringify(smsType.is_booking_sms),
      is_shown_to_pha: JSON.stringify(smsType.is_shown_to_pha),
      is_shown_to_sales: JSON.stringify(smsType.is_shown_to_sales),
      is_auto_verify: JSON.stringify(smsType.is_auto_verify),
      is_price_hide: JSON.stringify(smsType.is_price_hide),
      paymentmode: paymentMode,
      country: "1",
      credit_limit: creditLimit,
      packages: packageIds,
      // packages: null,
    };
    if (editButton) {
      delete formData.center_code;
    }
    if (editButton) {
      delete formData.name;
    }
    if (altNumber === "") {
      delete formData.alternative_phone;
    }
    if (sales_Manager === null) {
      delete formData.sales_manager;
    }
    if (ifscCode === "") {
      delete formData.bank_ifsc;
    }
    if (gstinNumber === "") {
      delete formData.gstin;
    }
    if (accountNumber === "") {
      delete formData.bank_account_no;
    }
    if (bankAccountHolder === "") {
      delete formData.account_holder_name;
    }
    if (bank === "") {
      delete formData.bank;
    }

    if (ownerName === "") {
      delete formData.owner_name;
    }
    if (designation === "") {
      delete formData.owner_salutation;
    }
    if (panNumber === "") {
      delete formData.pan;
    }
    if (minAmountForNotification === "") {
      delete formData.min_amnt_for_notification;
    }
    if (reportEmailSentTo === "") {
      delete formData.report_email_sent_to;
    }
    if (reportSmsSentTo === "") {
      delete formData.report_sms_sent_to;
    }
    if (reportWhatsappSentTo === "") {
      delete formData.report_whatsapp_sent_to;
    }
    if (invoiceCycle === "" || invoiceCycle === null) {
      delete formData.invoice_cycle;
    }
    if (creditLimit === "") {
      delete formData.credit_limit;
    }
  
    if (editButton) {
      await updateCenter(formData, centerId);
    } else {
      await createNewCenter(formData);
    }

    getCenterInfo();
    setEditButton(false);
    setCentreShow(false);
    setCentreHeadShow(false);
    setCentreBankShow(false);
    setCentreControllingShow(false);
    history.push("/dashboard/gnadmin/centerCreationModal");
  };
  let additionalPacakges = [];
  inputList &&
    inputList.length > 1 &&
    inputList.map((item: any, index: number) => {
      if (index > 0) {
        additionalPacakges.push(item);
      }
    });
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = centerInfo.links && centerInfo.links.next.split("?")[1];
      getCenterInfo(`?${url}`);
    } else if (newPage < page) {
      let url = centerInfo.links && centerInfo.links.previous.split("?")[1];
      getCenterInfo(`${url === undefined ? "" : "?" + url}`);
    }
    setPage(newPage);
  };  const handleEditCentre = (data: any) => {
    console.log("data", data);
    setPackageDetails(data?.packages);
    // setDisplayTagProcessingLab("");
    // setTag_ProccessingLab("")
    // setDisplayServiceRateCategory("");
    // setServiceRateCategory("")
    // setDisplayPackages("Blood Pressure screening");
    setCentreName(data?.display_name);
    setReportEmailSentTo(data?.report_email_sent_to);
    setCentreHeadContactNumber(data?.owner_phone);
    setDisplayDesignation(data?.owner_salutation);
    setSales_Manager(data?.sales_manager?.panel_user_id);
    setDisplaySalesManager(data?.sales_manager?.name);
    setServiceRateCategoryDef(data.ratelist[0]);
    setServiceRateCategory([data.ratelist[0]?.id]);
    setCategoryName(data?.type as string);
    setDisableEdit(true);
    setEditButton(true);
    setaltNumber(data?.alternative_phone);
    setPincodeId(data?.area?.id as Number);
    setPincodeIdDef(data?.area);
    // setCityId(data?.area?.city);
    setArea(data?.area?.area as String);
    setCityName(data?.area?.city_name as String);
    setBarCodeType(data?.barcode_type);
    setPaymentMode(data?.paymentmode);
    setBank(data?.bank?.id);
    setBankInput(data?.bank?.name ? data?.bank?.name : "");
    setPackageDef(data?.package);
    setPackageIds(data?.packages?.id)
    // setIdentityProof(data?.identity_proof);
    // setCentreHeadShow(true);
    // setCentreBankShow(true);
    // setCentreControllingShow(true);
    setCentreType(data?.center_type);
    setCentreCode(data?.center_code);
    setContractDate(data?.contract_start_date);
    setExpiryDate(data?.contract_end_date);
    setMobileNumber(data?.mobile);
    // setaltNumber(data?.alternative_phone);
    setCentreHeadContactNumber(data?.center_head_phone);
    setCentreHeadAlternateNumber(data?.owner_alt_phone);
    setDesignation(data?.owner_salutation);
    setCentreHeadContactNumber(data?.owner_phone);
    setEmail(data?.email);
    // setTenure();
    // setPaitentType(data.patient_type)
    // setSales_Manager(data?.sales_manager?.id);
    setSales_ManagerDef({
      id: data?.sales_manager?.panel_user_id,
      user: { username: data?.sales_manager?.name },
    });
    // salesManager.results &&
    //   salesManager.results.find((code: any) => {
    //     if (code.uuid === data.user) {
    //       setSales_ManagerDef(code);
    //     }
    //   });
    setOwnerName(data?.owner_name);
    setSales_Executive(data?.users);

    salesExecutive.results &&
      salesExecutive.results.map((code: any) => {
        data.users.map((dat: any) => {
          if (code.uuid === dat) {
            sales_ExecutiveDef.push(code);
          }
        });
      });

    setCentreAddress(data?.address);
    // setSecurityAmount(data?.security_amount);
  
    setBusyId(
      data?.busyID === null || data?.busyID === "null" ? "" : data?.busyID
    );
    setbankAccountHolder(data?.account_holder_name);
    setCreditLimit(data?.credit_limit);
    setGstinNumber(data?.gstin);
    setPanNumber(data?.pan);
    setInvoiceCycle(data?.invoice_cycle);
    setIfscCode(data?.bank_ifsc);
    setAccountNumber(data?.bank_account_no);
    setMinNotication(data?.min_amnt_for_notification);
    setMinAmountForBill(Number(data?.min_amnt_for_billing_lock));
    setCenterId(data?.id);
    setAdharNumber(data?.aadhar_no);
    setSmsType({
      mail: data.is_mail,
      sms: data.is_sms,
      screen: data.is_screen,
      isbillinglock: data?.is_billing_lock,
      isapproved: data.is_active,
      is_booking_payment_sms: data.is_booking_payment_sms,
      is_booking_sms: data.is_booking_sms,
      is_report_sms: data.is_report_sms,
      is_report_whatsapp: data.is_report_whatsapp,
      is_report_email: data.is_report_email,
      is_shown_to_pha: data.is_shown_to_pha,
      is_shown_to_sales: data.is_shown_to_sales,
      is_auto_verify: data.is_auto_verify,
      is_price_hide: data.is_price_hide,
    });
    setCentreShow(true);
  };
  useEffect(() => {
    getRateListFilter(tag_ProccessingLab, "");
  }, [tag_ProccessingLab]);
  useEffect(() => {
    if (categoryName !== "") {
      {
        paymentModeList.map((val: any) => {
          if (categoryName === "postpaid" && val.name === "Credit") {
            setPaymentMode(val.id);
          } else if (categoryName === "prepaid" && val.name === "Cash") {
            setPaymentMode(val.id);
          }
        });
      }
    }
    if (categoryName === "postpaid") {
      setMinAmountForBill(0);
    }
  }, [categoryName]);
  useEffect(() => {
    if (contractDate && tenure) {
      setExpiryDate(
        moment(contractDate).add(tenure, "year").format("YYYY-MM-DD")
      );
    }
  }, [contractDate, tenure]);

  const tagAllPackage = (val: any) => {
    if (val === true) {
      setIsAllPkg(val);
      setPackageDetails(centerPackages);
      let packagesAll: any = [];
      centerPackages &&
        centerPackages.length > 0 &&
        centerPackages.map((data: any) => {
          packagesAll.push(data.id);
        });
        setPackageIds(packagesAll);
    } else {
      setIsAllPkg(val);
      setPackageIds([]);
      setPackageDetails([]);
    }
  };
  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <div className={classes.contentHeader}>
        <h2 style={{ fontWeight: "bold" }}>CREATION MASTER</h2>
      </div>
      <form onSubmit={handleSubmitCentre}>
        <Paper elevation={5} className={classes.paper}>
          {/* <h4
            className={classes.hoveItem}
            style={{ fontWeight: "bold", background: "#924A91", color: "#fff" }}
            onClick={() => setCentreShow(centerShow ? false : true)}
          >
            {centerShow ? <ExpandLessIcon /> : <ExpandMoreIcon />} HOSPITAL/DOCTOR
            CREATION MASTER
          </h4> */}

          <Grid
            container
            spacing={3}
            direction="row"
            style={{ alignItems: "left" }}
          >
            <Grid item xs={12}>
              <h3
                style={{
                  borderTop: "dotted 1px #cccc",
                  paddingTop: "10px",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                HOSPITAL/DOCTOR CREATION MASTER
              </h3>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                className="input"
                name="title"
                type="text"
                label="Hospital/Doctor Code"
                value={centerCode}
                required
                disabled
                variant="outlined"
                style={{ margin: "0", width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                aria-required
                variant="outlined"
                label="Hospital/Doctor Type"
                value={centerType}
                // disabled={centerType === "collection_center"}
                required
                onChange={(e) => {
                  setCentreType(e.target.value);
                }}
              >
                <MenuItem value="hospital">Hospital </MenuItem>
                <MenuItem value="doctor">Doctor</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                className="input"
                name="center_name"
                type="text"
                label="Hospital/Doctor"
                value={centerName}
                required
                variant="outlined"
                onChange={(e) => setCentreName(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="centre_type"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setCentreType(obj.value);
                  }
                }}
                defaultValue={
                  CenterTypeData &&
                  CenterTypeData.find((code: any) => {
                    return code.value === centerType;
                  })
                }
                options={CenterTypeData}
                freeSolo
                blurOnSelect
                getOptionLabel={(option: any) => `${option.text}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Hospital/Doctor Type"
                    variant="outlined"
                    style={{ width: "100%" }}
                    className={classes.input}
                    required
                  />
                )}
              />
            </Grid> */}
               <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="customerPackage"
                key={packageDetails}
                onChange={(event, newValue) => {
                  if (newValue) {
                    let packs: any = [];
                    newValue.map((val: any) => {
                      let obj = JSON.parse(JSON.stringify(val, null, " "));
                      packs.push(obj.id);
                    });
                    setPackageIds(packs);
                  }
                }}
                defaultValue={packageDetails || []}
                multiple
                disableClearable
                options={centerPackages || []}
                limitTags={0}
                freeSolo
                disableCloseOnSelect
                aria-required
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getPackageByCenter(newInputValue);
                    setDisplayPackages(newInputValue);
                  }, 1000);
                }}
                getOptionLabel={(option: any) => {
                  // return option?.name;
                  return(option.name +
                        "(" +
                        option.code +
                        ")")
                }}
                getOptionDisabled={(option: any) => {
                 
                  return packageIds?.includes(option?.id);
                }}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={isAllPkg}
                    />
                    {option?.name + " (" + option?.code + ")"}
                  </React.Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Package"
                    variant="outlined"
                    style={{ width: "100%" }}
                    className={classes.input}
                    required={packageDetails?.length===0?true:false}
                   
                  />
                  
                )}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllPkg}
                    onChange={(e) => tagAllPackage(e.target.checked)}
                    color="primary"
                  />
                }
                label="Select All Package"
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllPkg}
                    onChange={(e) => tagAllPackage(e.target.checked)}
                    color="primary"
                  />
                }
                label="Select All Package"
              />
              </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="contract_date"
                type="date"
                value={contractDate}
                className="input"
                label="Contract Date"
                variant="outlined"
                required
                inputProps={{
                  min: editButton
                    ? moment(contractDate).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD"),
                }}
                // min={`${new Date().getFullYear()}-${(new Date().getMonth() + 1) < 10 ? `0${(new Date().getMonth() + 1)}` : (new Date().getMonth() + 1)}-${new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()}`}
                onChange={(e) => setContractDate(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                aria-required
                variant="outlined"
                label="Tenure"
                value={tenure}
                // disabled={centerType === "collection_center"}
                onChange={(e) => setTenure(e.target.value)}
              >
                <MenuItem value="1">1 Year </MenuItem>
                <MenuItem value="2">2 Year</MenuItem>
                <MenuItem value="3">3 Year</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="expiry_date"
                type="date"
                disabled
                value={expiryDate}
                className="input"
                label="Expiry Date"
                variant="outlined"
                style={{ width: "100%" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                className="input"
                name="mobile_number"
                type="number"
                label="Mobile Number"
                value={mobileNumber}
                variant="outlined"
                inputProps={{ maxLength: 10 }}
                style={{ margin: "0", width: "100%" }}
                onChange={(e) => setMobileNumber(e.target.value as String)}
                required
                onWheel={(e: any) => e.target.blur()}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                onBlur={() => verifyMobile("mob")}
                onFocus={() => {
                  setMobileValidation((prev: any) => ({
                    ...prev,
                    mobileNumber: true,
                  }));
                }}
                helperText={
                  !mobileValidation.mobileNumber && "Incorrect Mobile Number"
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                className="input"
                name="alt_number"
                type="number"
                label="Alternate Number"
                value={altNumber}
                variant="outlined"
                inputProps={{ maxLength: 10 }}
                style={{ margin: "0", width: "100%" }}
                onChange={(e) => setaltNumber(e.target.value as String)}
                onWheel={(e: any) => e.target.blur()}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                onBlur={() => verifyMobile("centAlt")}
                onFocus={() => {
                  setMobileValidation((prev: any) => ({
                    ...prev,
                    altNumber: true,
                  }));
                }}
                helperText={
                  !mobileValidation.altNumber && "Incorrect Alternate Number"
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="email"
                type="email"
                value={email}
                className="input"
                label="Email "
                variant="outlined"
                onChange={(e) => setEmail(e.target.value as string)}
                style={{ width: "100%" }}
                required
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={3}> */}
            {/* <Autocomplete
                  id="identityproof"
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      setIdentityProof(obj.id);
                    }
                  }}
                  defaultValue={
                    identityProofData &&
                    identityProofData.find((code: any) => {
                      return code.id === Number(identityProof);
                    })
                  }
                  options={identityProofData || []}
                  freeSolo
                  blurOnSelect
                  getOptionLabel={(option: any) => `${option.name}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Identity Proof"
                      variant="outlined"
                      style={{ width: "100%" }}
                      className={classes.input}
                      required
                    />
                  )}
                /> */}
            {/* </Grid> */}
            {/* <Grid item xs={12} sm={6} md={3}>
              <input
                className="input"
                style={{
                  width: "100%",
                  margin: "0",
                  padding: "18.5px 14px",
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "5px",
                }}
                type="file"
                name="file"
                id="file"
                multiple
                onChange={fileSelectedHandler}
              />
            </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="sales_manager"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setSales_Manager(obj.panel_user_id);
                  }
                }}
                defaultValue={
                  sales_ManagerDef || { id: "",  username: "" }
                }
                options={salesManager.results || []}
                freeSolo
                blurOnSelect
                getOptionLabel={(option: any) => `${option?.username}`}
                inputValue={displaySalesManager}
                onInputChange={(event, newInputValue) => {
                  setDisplaySalesManager(newInputValue);
                  getSalesManager(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sales Manager"
                    variant="outlined"
                    style={{ width: "100%" }}
                    className={classes.input}
                    required
                  />
                )}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  id="sales_executive"
                  onChange={(event, newValue) => {
                    let sourceIds: any = [];
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      sourceIds = obj.map((item: any) => item.uuid);
                    }
                    setSales_Executive(sourceIds);
                  }}
                  defaultValue={sales_ExecutiveDef}
                  multiple
                  freeSolo
                  blurOnSelect
                  limitTags={2}
                  options={salesExecutive.results || []}
                  getOptionDisabled={(option: any) => {
                    return sales_Executive.includes(option?.id);
                  }}
                  disableClearable
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => `${option?.username}`}
                  onInputChange={(event, newInputValue) => {
                    getSalesExecutive(newInputValue);

                    if (newInputValue.length === 0) {
                      setSales_Executive([]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      className={classes.input}
                      {...params}
                      label="Sales Executive"
                      variant="outlined"
                      style={{ width: "100%", margin: "0", padding: "0" }}
                    />
                  )}
                />
              </Grid> */}

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="centerAddress"
                type="text"
                value={centerAddress}
                className="input"
                label="Hospital/Doctor Address"
                variant="outlined"
                onChange={(e) => setCentreAddress(e.target.value as string)}
                style={{ width: "100%" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
                id="tag_processinglab"
                
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setTag_ProccessingLab(obj.id);
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue.length === 0) {
                    getRateListFilter("", "");
                    setTag_ProccessingLab("");
                  }
                }}
              
                options={tagProccessingLab.results || []}
                freeSolo
                disableClearable
                blurOnSelect
                getOptionLabel={(option: any) => `${option?.name}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Lab to filter Service Rate Category"
                    variant="outlined"
                    fullWidth
                    className={classes.input}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="serviceRateCate"
                key={editButton}
                onChange={(event, newValue) => {
                  // let sourceIds: any = [];
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setServiceRateCategory([obj.id]);
                  }
                }}
                options={rateListFilter.results || []}
                freeSolo
                defaultValue={serviceRateCategoryDef}
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) => `${option?.name}`}
                inputValue={displayServiceCategory}
                onInputChange={(event, newInputValue) => {
                  setDisplayServiceRateCategory(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="Service Rate Category"
                    variant="outlined"
                    style={{ width: "100%" }}
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                variant="outlined"
                label="Category Name"
                
                value={categoryName}
                // disabled={centerType === "collection_center"}
                required
                onChange={(e) => setCategoryName(e.target.value)}
              >
                <MenuItem value="prepaid">Prepaid</MenuItem>
                <MenuItem value="postpaid">Postpaid</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                label="Payment Mode"
                variant="outlined"
                fullWidth
                value={paymentMode}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
                required
              >
                {paymentModeList.map((val: any) => (
                  <MenuItem value={val.id}>{val.name}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                select
                fullWidth
                aria-required
                variant="outlined"
                label="Barcode Type"
                value={barCodeType}
                required
                onChange={(e) => setBarCodeType(e.target.value)}
              >
                <MenuItem value="preprainted">Pre Printed</MenuItem>
                {/* <MenuItem value="systemgenerated">System Genrated</MenuItem> */}
              </TextField>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="busyId"
                  type="text"
                  value={busyId}
                  className="input"
                  label="Busy Id "
                  variant="outlined"
                  onChange={(e) => setBusyId(e.target.value as string)}
                  style={{ width: "100%" }}
                />
              </Grid> */}
            {/* <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="Adhar_Number"
                  type="number"
                  value={adharNumber}
                  className="input"
                  label="Aadhaar Number "
                  variant="outlined"
                  onWheel={(e: any) => e.target.blur()}
                  onInput={(e: any) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 12);
                  }}
                  helperText={
                    adharNumber?.length < 12 || adharNumber === null
                      ? "Enter a valid 12 Digit Aadhaar No."
                      : ""
                  }
                  onChange={(e) => setAdharNumber(e.target.value as string)}
                  style={{ width: "100%" }}
                />
              </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="pincode"
                key={pinCodeIdDef}
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setPincodeId(obj?.id as Number);
                    setArea(obj.area as String);
                    setCityName(obj.city as String);
                    setCityId(obj.cityid);
                  }
                }}
                defaultValue={
                  pinCodeIdDef || {
                    id: "",
                    area: "",
                    city: "",
                    cityid: "",
                    pincode: "",
                  }
                }
                options={pin_code?.results || []}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) =>
                  option.pincode !== ""
                    ? `${option.pincode + "," + option.area}`
                    : ""
                }
                onInputChange={(event, newInputValue) => {
                  //   clearTimeout(timer.current);
                  //   timer.current = setTimeout(() => {
                  //   }, 1000);
                  getPinCode(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="Pin Code"
                    variant="outlined"
                    style={{ width: "100%", margin: "0", padding: "0" }}
                    required
                  />
                )}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="area"
                  type="text"
                  value={area}
                  className="input"
                  label="Area "
                  variant="outlined"
                  disabled
                  style={{ width: "100%" }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="city"
                  type="text"
                  value={cityName}
                  className="input"
                  label="City Name "
                  variant="outlined"
                  disabled
                  style={{ width: "100%" }}
                  required
                />
              </Grid> */}
            <Grid item xs={12}>
              <h3
                style={{
                  borderTop: "dotted 1px #cccc",
                  paddingTop: "10px",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Hospital/Doctor Owner Details
              </h3>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="salutation"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setDesignation(obj.value);
                  }
                }}
                defaultValue={
                  salutationData &&
                  salutationData.find((code: any) => {
                    return code.value === designation;
                  })
                }
                options={salutationData}
                freeSolo
                blurOnSelect
                getOptionLabel={(option: any) => option.text}
                inputValue={displayDesignation}
                onInputChange={(event, newInputValue) => {
                  setDisplayDesignation(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="Salutation"
                    variant="outlined"
                    style={{ width: "100%" }}
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Ownername"
                type="text"
                value={ownerName}
                className="input"
                label="Owner Name"
                variant="outlined"
                onChange={(e) => setOwnerName(e.target.value as string)}
                style={{ width: "100%" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="nationality"
                type="text"
                value={nationality}
                className="input"
                label="Nationality"
                variant="outlined"
                onChange={(e) => setNationality(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                className="input"
                name="contact"
                type="number"
                label="Hospital/Doctor Mobile Number"
                value={centerHeadalContactNumber}
                variant="outlined"
                style={{ margin: "0", width: "100%" }}
                onChange={(e) =>
                  setCentreHeadContactNumber(e.target.value as String)
                }
                onBlur={() => verifyMobile("contMob")}
                onFocus={() => {
                  setMobileValidation((prev: any) => ({
                    ...prev,
                    centerHeadalContactNumber: true,
                  }));
                }}
                onWheel={(e: any) => e.target.blur()}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                helperText={
                  !mobileValidation.centerHeadalContactNumber &&
                  "Incorrect Mobile Number"
                }
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                className="input"
                name="contact"
                type="number"
                label="Hospital/Doctor Alternate Number"
                value={centerHeadalterNateNumber}
                variant="outlined"
                style={{ margin: "0", width: "100%" }}
                onChange={(e) =>
                  setCentreHeadAlternateNumber(e.target.value as String)
                }
                onWheel={(e: any) => e.target.blur()}
                onInput={(e: any) => {
                  e.target.value = Math.max(0, parseInt(e.target.value))
                    .toString()
                    .slice(0, 10);
                }}
                onBlur={() => verifyMobile("contAlt")}
                onFocus={() => {
                  setMobileValidation((prev: any) => ({
                    ...prev,
                    centerHeadalterNateNumber: true,
                  }));
                }}
                helperText={
                  !mobileValidation.centerHeadalterNateNumber &&
                  "Incorrect Alternate Number"
                }
              />
            </Grid>
            <Grid item xs={12}>
              <h3
                style={{
                  borderTop: "dotted 1px #cccc",
                  paddingTop: "10px",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Hospital/Doctor Bank Details
              </h3>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="acountholder"
                type="text"
                value={bankAccountHolder}
                className="input"
                label="Account Holder Name"
                variant="outlined"
                onChange={(e) => setbankAccountHolder(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="bank"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setBank(obj.id);
                  }
                }}
                defaultValue={
                  bankName.count > 0 &&
                  bankName.results.find((code: any) => {
                    return code.id === bank;
                  })
                }
                freeSolo
                blurOnSelect
                options={bankName?.results}
                disableCloseOnSelect
                getOptionLabel={(option: any) => option.name}
                inputValue={bankInput}
                onInputChange={(event, newInputValue) => {
                  getBankName(`?name=${newInputValue}`);
                  setBankInput(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Bank Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="GSTINNumber"
                type="text"
                value={gstinNumber}
                className="input"
                label="GSTIN"
                variant="outlined"
                onChange={(e) => setGstinNumber(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="panNumber"
                type="text"
                value={panNumber}
                className="input"
                label="PAN"
                variant="outlined"
                // inputProps={{ style: { textTransform: "uppercase" } }}
                onChange={(e) =>
                  setPanNumber(String(e.target.value).toUpperCase())
                }
                style={{ width: "100%" }}
                helperText="Ex:- ABCDE9999F"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="IFSC"
                type="text"
                value={ifscCode}
                className="input"
                label="IFSC Code"
                variant="outlined"
                onChange={(e) => setIfscCode(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="accountNumber"
                type="number"
                value={accountNumber}
                className="input"
                label="Account Number"
                variant="outlined"
                onChange={(e) => setAccountNumber(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12}>
              <h3
                style={{
                  borderTop: "dotted 1px #cccc",
                  paddingTop: "10px",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Account Controling Details
              </h3>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="minamountfornoti"
                type="number"
                value={minAmountForNotification}
                className="input"
                label="Min Amt. For Notification *"
                variant="outlined"
                onChange={(e) => setMinNotication(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="minamountforbill"
                type="number"
                value={minAmountForBill}
                disabled={categoryName === "postpaid"}
                className="input"
                label="Min Amt For Bill *"
                variant="outlined"
                onChange={(e) => setMinAmountForBill(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Package Rights"
                value={packageRights}
                select
                required
                label="Package Rights"
                variant="outlined"
                disabled={centerType !== "corporate"}
                onChange={(e) => setPackageRights(e.target.value)}
                fullWidth
              >
                <MenuItem value="redcliffe">Redcliffe</MenuItem>
                <MenuItem value="self">Self</MenuItem>
                <MenuItem value="both">Both</MenuItem>
                <MenuItem value="all">All</MenuItem>
              </TextField>
            </Grid>
            {categoryName === "postpaid" ? (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Credit Limit"
                    type="number"
                    value={creditLimit}
                    className="input"
                    required
                    label="Credit Limit"
                    variant="outlined"
                    onChange={(e) => setCreditLimit(e.target.value as string)}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Credit Limit"
                    type="number"
                    value={invoiceCycle}
                    select
                    required
                    label="Invoice Cycle"
                    variant="outlined"
                    onChange={(e) => setInvoiceCycle(e.target.value)}
                    fullWidth
                  >
                    {/* <MenuItem value="2">2 Days</MenuItem> */}
                    <MenuItem value="15">15 Days</MenuItem>
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="15">45 Days</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Credit Limit"
                    type="number"
                    value={invoiceCycle}
                    select
                    required
                    label="Billing Cycle"
                    variant="outlined"
                    onChange={(e) => setInvoiceCycle(e.target.value)}
                    fullWidth
                  >
                    {/* <MenuItem value="2">2 Days</MenuItem> */}
                    <MenuItem value="15">15 Days</MenuItem>
                    <MenuItem value="monthly">Monthly</MenuItem>
                    <MenuItem value="15">45 Days</MenuItem>
                  </TextField>
                </Grid>
              </>
            ) : (
              ""
            )}
            {/* <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Report Whatsapp Sent To"
                type="number"
                value={reportWhatsappSentTo}
                select
                label="Report Whatsapp Sent To"
                variant="outlined"
                onChange={(e) => setReportWhatsappSentTo(e.target.value)}
                fullWidth
              >
                <MenuItem value="client">Client</MenuItem>
                <MenuItem value="customer">Customer</MenuItem>
                <MenuItem value="both">Both</MenuItem>
                <MenuItem value="not_send">Not Send</MenuItem>
              </TextField>
            </Grid> */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                type="number"
                value={reportEmailSentTo}
                select
                label="Report Email Sent To"
                variant="outlined"
                onChange={(e) => setReportEmailSentTo(e.target.value)}
                fullWidth
              >
                <MenuItem value="client">Client</MenuItem>
                <MenuItem value="customer">Customer</MenuItem>
                <MenuItem value="both">Both</MenuItem>
                <MenuItem value="not_send">Not Send</MenuItem>
              </TextField>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={3}>
              <TextField
                type="number"
                value={reportSmsSentTo}
                select
                label="Report Sms Sent To"
                variant="outlined"
                onChange={(e) => setReportSmsSentTo(e.target.value)}
                fullWidth
              >
                <MenuItem value="client">Client</MenuItem>
                <MenuItem value="customer">Customer</MenuItem>
                <MenuItem value="both">Both</MenuItem>
                <MenuItem value="not_send">Not Send</MenuItem>
              </TextField>
            </Grid> */}
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isbillinglock"
                      checked={smsType.isbillinglock}
                    />
                  }
                  onChange={handleSmsControl}
                  label="Is Billing Lock"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_booking_payment_sms"
                      checked={smsType.is_booking_payment_sms}
                    />
                  }
                  onChange={handleSmsControl}
                  label="Booking payment sms"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_booking_sms"
                      checked={smsType.is_booking_sms}
                    />
                  }
                  onChange={handleSmsControl}
                  label="booking sms"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_shown_to_pha"
                      checked={smsType.is_shown_to_pha}
                    />
                  }
                  onChange={handleSmsControl}
                  label="shown to oops"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_shown_to_sales"
                      checked={smsType.is_shown_to_sales}
                    />
                  }
                  onChange={handleSmsControl}
                  label="shown to sales"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_auto_verify"
                      checked={smsType.is_auto_verify}
                    />
                  }
                  onChange={handleSmsControl}
                  label="auto verify"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_price_hide"
                      checked={smsType.is_price_hide}
                    />
                  }
                  onChange={handleSmsControl}
                  label="price hide"
                />
              </FormGroup>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            direction="row"
            style={{ alignItems: "right" }}
          >
            <Grid item xs={12} sm={6} md={3}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={
                  !mobileValidation.mobileNumber ||
                  !mobileValidation.altNumber ||
                  !mobileValidation.centerHeadalContactNumber ||
                  !mobileValidation.centerHeadalterNateNumber
                }
                type="submit"
              >
                {editButton ? "Update Centre" : "Create Hospital/Doctor"}
              </Button>
            </Grid>
            {!editButton ? (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => {
                    history.push("/dashboard/gnadmin/centerCreationModal");
                    setCentreCode("");
                  }}
                >
                  Reset
                </Button>
              </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() =>
                    history.push("/dashboard/gnadmin/centerCreationModal")
                  }
                >
                  Cancel Update
                </Button>
              </Grid>
            )}
          </Grid>
        </Paper>
      </form>
      <Paper elevation={5} className={classes.paper}>
        <Grid
          container
          spacing={3}
          className={classes.centerIt}
          style={{
            margin: "1rem auto",
          }}
        >
          <Grid item xs={12} sm={6} md={2}>
            <h5 style={{ marginTop: 15 }}>Search Option </h5>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              className={classes.input}
              label="Hospital/Doctor"
              variant="outlined"
              fullWidth
              onChange={(e) => getCenterInfo(`&name_or_code=${e.target.value}`)}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Button
              variant="contained"
              color="secondary"
              style={{ height: "56px" }}
              fullWidth
              onClick={() =>
                history.push("/dashboard/gnadmin/centerCreationModal")
              }
            >
              Reset
            </Button>
          </Grid>
        </Grid>

        <div
          className="data-table"
          style={{ width: "100%", marginTop: "1rem" }}
        >
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "515px" }}
          >
            {loading ? (
              <Loader />
            ) : (
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">
                      Hospital/Doctor Name
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Hospital/Doctor Code
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Hospital/Doctor Owner
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Hospital/Doctor Email
                    </StyledTableCell>
                    <StyledTableCell align="center">Number</StyledTableCell>
                    <StyledTableCell align="center">
                      Created Date
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Expiry Date
                    </StyledTableCell>
                    {/* <StyledTableCell align="center">State</StyledTableCell>
                    <StyledTableCell align="center">City</StyledTableCell>
                    <StyledTableCell align="center">
                      Address/Inactive
                    </StyledTableCell> */}
                    <StyledTableCell align="center">
                      Assigned Lab
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Service Rate Category
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Hospital/Doctor Type
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      Edit Centre
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {centerInfo &&
                    centerInfo.results &&
                    centerInfo.results.length > 0 &&
                    centerInfo.results.map((data: any, index: any) => {
                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center">
                            {data?.display_name === null
                              ? data?.name
                              : data?.display_name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data?.center_code}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data?.owner_name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data?.email}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data?.mobile}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {data?.contract_start_date}{" "}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {data?.contract_end_date}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data?.ratelist[0]?.assigned_lab}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data?.ratelist[0]?.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {" "}
                            {data.center_type}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <Button
                              disabled={disableEdit}
                              color="primary"
                              variant="contained"
                            >
                              <Edit onClick={() => handleEditCentre(data)} />
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                <TableFooter>
                  <TablePagination
                    colSpan={6}
                    count={centerInfo.count || 0}
                    rowsPerPageOptions={[]}
                    rowsPerPage={rowsPerPage}
                    // onChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                  />
                </TableFooter>
              </Table>
            )}
          </TableContainer>
        </div>
      </Paper>
    </main>
  );
};
const mapStateToProps = (state: any) => ({
  loading: state.GenomicsAdminReducer.loading,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  centreCode: state.GenomicsAdminReducer.centreCode,
  pin_code: state.GenomicsAdminReducer.pin_code,
  agentBYUserGroup: state.GenomicsAdminReducer.agentBYUserGroup,
  salesManager: state.GenomicsAdminReducer.salesManager,
  salesExecutive: state.GenomicsAdminReducer.salesExecutive,
  identityProofData: state.GenomicsAdminReducer.identityProofData,
  stateList: state.GenomicsAdminReducer.stateList,
  paymentModeList: state.GenomicsAdminReducer.paymentModeList,
  rateListFilter: state.GenomicsAdminReducer.rateListFilter,
  tagProccessingLab: state.GenomicsAdminReducer.tagProccessingLab,
  centerPackages: state.GenomicsAdminReducer.centerPackages,
  multiplePackage: state.GenomicsCustomerExecutiveReducer.multiplePackage,
  bankName: state.GenomicsAdminReducer.bankName,
  allPackageList:state.GenomicsAdminReducer.allPackageList,
});
export default connect(mapStateToProps, {
  getCenterInfo,
  getPinCode,
  createNewCenter,
  getBankName,
  getAgentList,
  getSalesExecutive,
  getSalesManager,
  updateCenter,
  getIdentityProof,
  getStateList,
  getpaymentMoodList,
  getRateListFilter,
  getTagProcessingLab,
  getCentreCode,
  getPackageByCenter,
})(CreateCentrePage);
